document.addEventListener('DOMContentLoaded', () => {
  const headerRef = document.querySelector('#header')
  const headerContainer = headerRef.querySelector('#headerContainer')
  const menuBtn = document.querySelector('#menuBurgerBtn')
  const moreBtn = document.querySelector('#moreBtn')
  const megaMemuRef = document.querySelector('#megaMenu')
  const body = document.querySelector('body')

  const openClass = 'open-mega-menu'
  const closeClass = 'close-mega-menu'

  let isMobile = false
  let isOpen = false

  if (window.innerWidth < 990) {
    isMobile = true
  }

  const handleToggleMenu = e => {
    if (isMobile) {
      if (!isOpen) {
        body.classList.add('overflow-hidden', 'fixed')
        headerContainer.classList.add('bg-slate-900')
        headerContainer.classList.remove('bg-transparent')
      } else {
        body.classList.remove('overflow-hidden', 'fixed')
        headerContainer.classList.remove('bg-slate-900')
      }
    }

    // e.target.querySelector('#burgerIcon').classList.toggle('hidden')
    // e.target.querySelector('#closeIcon').classList.toggle('hidden')
    if (!isOpen) {
      megaMemuRef.classList.remove(closeClass)
      megaMemuRef.classList.add(openClass)

      menuBtn.querySelector('#burgerIcon').classList.add('hidden')
      menuBtn.querySelector('#closeIcon').classList.remove('hidden')
    } else {
      megaMemuRef.classList.remove(openClass)
      megaMemuRef.classList.add(closeClass)
      menuBtn.querySelector('#burgerIcon').classList.remove('hidden')
      menuBtn.querySelector('#closeIcon').classList.add('hidden')
    }
    isOpen = !isOpen
  }

  const handleResizeAndChangeScroll = () => {
    if (window.innerWidth >= 990) {
      isMobile = true
      body.classList.remove('overflow-hidden')
    }
  }

  const closeMenu = () => {
    if (isOpen) {
      megaMemuRef.classList.remove(openClass)
      megaMemuRef.classList.add(closeClass)
      menuBtn.querySelector('#burgerIcon').classList.remove('hidden')
      menuBtn.querySelector('#closeIcon').classList.add('hidden')
      body.classList.remove('overflow-hidden')
      headerContainer.classList.remove('bg-slate-900')
      isOpen = false
    }
  }

  const handleClickOutside = event => {
    if (!menuBtn.contains(event.target) && !moreBtn.contains(event.target) && !megaMemuRef.contains(event.target) && !headerContainer.contains(event.target)) {
      if (megaMemuRef.classList.contains(closeClass)) {
        return
      }

      document.body.classList.remove('overflow-hidden', 'fixed')
      megaMemuRef.classList.remove(openClass)
      megaMemuRef.classList.add(closeClass)
      menuBtn.querySelector('#burgerIcon').classList.remove('hidden')
      menuBtn.querySelector('#closeIcon').classList.add('hidden')
      isOpen = false
    }
  }
  menuBtn.addEventListener('click', handleToggleMenu)
  moreBtn.addEventListener('click', handleToggleMenu)

  window.addEventListener('resize', handleResizeAndChangeScroll)

  document.addEventListener('click', handleClickOutside)

  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      closeMenu()
      menuBtn.blur()
    }
  })

  let lastScrollTop = 0;
  const scrollThreshold = 0; // 100px threshold

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Toggle header visibility based on scroll direction and position
    if (currentScroll > lastScrollTop && currentScroll > scrollThreshold) {
      // Scrolling down and beyond threshold
      headerRef.classList.add('opacity-0', 'pointer-events-none');
    } else if (currentScroll < lastScrollTop || currentScroll <= scrollThreshold) {
      // Scrolling up or within threshold
      headerRef.classList.remove('opacity-0', 'pointer-events-none');
    }

    // Toggle header background based on scroll position
    if (currentScroll > 0) {
      headerRef.classList.add('bg-slate-900');
    } else {
      headerRef.classList.remove('bg-slate-900');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
  });

  window.addEventListener('load', () => {
    if (window.scrollY > 0) {
      headerRef.classList.add('bg-slate-900');
    }
  });
})


